<template>
    <div
        class="nav-link text-white px-0 d-flex d-flex flex-column nav-expand-group h-100"
        @mouseover="autoExpand = true"
        @mouseleave="autoExpand = false"
    >
        <div class="text-white px-0 d-flex align-items-center">
            <i
                class="fa-solid fa-2x icon"
                :class="navitem.icon"
            ></i>
            <span
                v-if="!minimalized"
                class="ms-2 h-100 fw-semibold"
            >{{ navitem.label }}</span>
        </div>
        <div
            class="childc border-end border-white border-3"
            :style="'height: ' + height"
        >
            <div
                v-for="child in navitem.childeren"
                :key="child"
                class="childeren"
            >
                <router-link
                    v-if="child.route"
                    :to="child.route"
                    class="nav-link text-white px-0 d-flex align-items-center"
                    :class="{
                        active: $route.name == child.route.name,
                        disabled: child.disabled,
                    }"
                >
                    <i
                        class="fa-solid fa-2x icon"
                        :class="child.icon"
                    ></i>
                    <span
                        v-if="!minimalized"
                        class="ms-2 h-100"
                    >{{ child.label }}</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<style scoped>
.icon {
    width: 40px;
    text-align: center;
}

.sidebar-a span {
    text-wrap: nowrap;
    overflow: hidden;
}

.childc {
    transition: height 0.5s;
    overflow: hidden;
}
</style>

<script>
export default {
    name: "SidebarNavGroupItem",
    props: { minimalized: { type: Boolean }, navitem: { type: Object } },
    data() {
        return {
            autoExpand: false,
            manualExpand: false,
        };
    },
    computed: {
        collapsed() {
            return !(this.autoExpand || this.manualExpand);
        },
        height() {
            return this.collapsed ? "0px;" : 44.8 * this.navitem.childeren.length + 3 + "px";
        },
    },
    methods: {
        handleShowHideButton(autoExpand, manualExpand) {
            // Close sidebar when manually opened
            if (manualExpand) {
                this.manualExpand = false;
                this.autoExpand = false;
                return;
            }

            // Close sidebar when automatically opened
            if (autoExpand) {
                this.autoExpand = false;
                return;
            }

            // Open sidebar
            this.manualExpand = true;
        },
    },
};
</script>
